import app from 'firebase/app';
import { executeSearchQuery } from './firestoreUtils';

const getPostCollection = () => app.firestore().collection('teams');

export const getUserTeams = userId => {
    let docRef = getPostCollection().where('ownerId', '==', userId);
    return docRef
        .get()
        .then(function (docs) {
            const res = [];
            docs.forEach(doc => {
                if (doc.exists) {
                    res.push(doc.data());
                } else {
                    console.log('No such document!');
                }
            });
            return res;
        })
        .catch(function (error) {
            console.log('Error getting document:', error);
        });
};

export const createTeam = dto => {
    return new Promise(function (resolve, reject) {
        const docRef = getPostCollection().doc();
        dto.teamId = docRef.id;
        docRef.set({ ...dto });
        if (docRef && docRef.id) {
            resolve(docRef.id);
        } else {
            reject('Object not created');
        }
    });
};

export const updateTeam = dto => {
    return new Promise(function (resolve, reject) {
        const docRef = getPostCollection().doc(dto.teamId);
        docRef.update({ ...dto });
        if (docRef && docRef.id) {
            resolve(docRef.id);
        } else {
            reject('Object not created');
        }
    });
};

export const removeTeam = uid => {
    return getPostCollection().doc(uid).delete();
};
